import classNames from 'classnames'
import './style.styl'
import Img from '../Img'
import { Conditional } from 'iq-blueberry'

const FormContainer = ({ children, imageSrc, className, noPaddingTop }) => {
  const componentClass = classNames('app-form-container', {
    'app-form-container--no-padding-top': !!noPaddingTop,
    'app-form-container--has-image': !!imageSrc,
    [className]: !!className,
  })
  return (
    <div className={componentClass}>
      <div className='app-form-container__content'>
        {children}
      </div>
      <Conditional
        condition={!!imageSrc}
        renderIf={<Img className="app-form-container__image" src={imageSrc} />}
      />
    </div>
  )
}

export default FormContainer
